import styled from 'styled-components'
import { ASSET_PREFIX } from '~/constants/env'

export const StyledArrow = styled.img.attrs({
  src: `${ASSET_PREFIX}/images/arrow-round.svg`,
})`
  width: 18px;
  height: 18px;
`

export const StyledTipLink = styled.a`
  background: #feb61d;
  border-radius: 8px;
  color: #ffffff;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  padding: 14px 16.5px;
  position: relative;
  margin: 10px 0 20px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    color: #ffffff;
  }

  &:active,
  &:focus {
    color: #ffffff;
    &::before {
      background: ${({ theme }) => theme.colors.textTitle};
      border-radius: 8px;
      content: '';
      height: 100%;
      left: 0;
      opacity: 0.15;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  span {
    display: block;
    width: 100%;
    margin-right: -14px;
  }
`
